import { TPromoCompilationType } from '../../../types/promoSelection';

export const getPromoCompilationBackgroundColor = (type: TPromoCompilationType) => {
  switch (type) {
    case 'topPromos':
      return '#152242';
    case 'lastChanceDiscount':
      return 'white';
  }
};
